import { render } from "./ScanFolhetoTable.vue?vue&type=template&id=19136942&scoped=true"
import script from "./ScanFolhetoTable.vue?vue&type=script&lang=js"
export * from "./ScanFolhetoTable.vue?vue&type=script&lang=js"

import "./ScanFolhetoTable.vue?vue&type=style&index=0&id=19136942&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19136942"]])

export default __exports__